import { useContext, useCallback, useEffect } from "react";
import { BsArrowRepeat } from "react-icons/bs";

import { ModalContext } from "@evos/components";
import { AuthContext } from "lib/context/auth";

type GlobalNotificationModalProps = {
  expiredTokenError: boolean | undefined;
  isIdle: boolean | undefined;
  unknownUserError: boolean | undefined;
};

export default function GlobalNotificationModal({
  expiredTokenError,
  isIdle,
  unknownUserError
}: GlobalNotificationModalProps) {
  const { showModal, handleModal } = useContext(ModalContext);
  const auth = useContext(AuthContext);

  const handleNotificationModals = useCallback((type: string) => {
    switch (type) {
    case "tokenExpired":
      handleModal({
        content: "Your session has expired. Please refresh the page to login again.",
        title: "Session Expired",
        size: "md",
        confirmButtonText: <><BsArrowRepeat className="me-1"/>Refresh</>,
        enableCloseButton: false,
        handleConfirm: () => {
          location.pathname.includes("authorization")
            ? window.location.replace("/")
            : window.location.reload();
        }
      });
      break;  
    case "unknownUser":
      handleModal({
        content: "Your user is not authorised to view the EVOS Monitoring Dashboard. Please contact the administrator for access.",
        title: "Unauthorised User",
        size: "md",
        confirmButtonText: "Sign Out",
        enableCloseButton: false,
        handleConfirm: async () => {
          auth?.signout(() => {
            window.localStorage.removeItem("redirectUrl");
          });
        }
      });
      break;
    }
  }, [auth, handleModal]);

  useEffect(() => {
    if (expiredTokenError === true && isIdle === true && !showModal) {
      handleNotificationModals("tokenExpired");
    }
  }, [expiredTokenError, handleNotificationModals, isIdle, showModal]);

  useEffect(() => {
    if (unknownUserError === true && !showModal) {
      handleNotificationModals("unknownUser");
    }
  });

  return(null);
}
